import * as v0 from "@aidkitorg/types/lib/survey";
import { hash } from "@aidkitorg/types/lib/translation/v0_to_legacy";
import { useState, useEffect } from "react";
import { usePost } from "../API";

export default function AutomaticMessageHandler(props: { amh: v0.CommsConfig['automaticMessageHandler'] }) {
  const getDryModeLogs = usePost("/admin/amh/get_dry_mode_logs");
  const [logs, setLogs] = useState<Awaited<ReturnType<typeof getDryModeLogs>> | null>(null);

  useEffect(() => {
    (async () => {
      setLogs(await getDryModeLogs({ amh: props.amh }));
    })();
  }, [])

  return <>
    {props.amh?.handlers?.map((h) => (
      <div key={h.id}>
        <h3>{h.name}</h3>
        <pre>EnableKey: {hash(JSON.stringify({ ...h, enableKey: '' }))}</pre>
        {Object.entries(logs?.[h.id] || {}).map(([key, value]) => (
          <>
            <h4>{key}</h4>
            <ul>{Array.isArray(value)
              ? value.map(v => <li key={JSON.stringify(v)}><pre>{JSON.stringify(v, undefined, 2)}</pre></li>)
              : typeof value === 'object'
                ? <li key={JSON.stringify(value)}><pre>{JSON.stringify(value, undefined, 2)}</pre></li>
                : <li key={value}>{value}</li>}
            </ul>
          </>
        ))}
      </div>
    ))}
  </>
}